<div data-testid="tag-input-container" class="tag-input-container">
  <!-- Textarea with inline tags -->
  <div
    data-testid="tag-input-wrapper"
    class="tag-input-wrapper"
    (click)="focusInput()"
  >
    <div data-testid="tag-input-content" class="tag-input-content">
      <!-- Tags display inline -->
      @for (tag of tags; track $index) {
        <span
          [attr.data-testid]="'tag-input-tag-' + $index"
          class="inline-flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-800 rounded-md text-sm tag-item"
        >
          {{ tag }}
          <button
            [attr.data-testid]="'tag-input-remove-btn-' + $index"
            type="button"
            class="text-blue-600 hover:text-blue-800 focus:outline-none remove-button"
            (click)="removeTag($index); $event.stopPropagation()"
            [disabled]="disabled"
          >
            <i class="pi pi-times text-xs"></i>
          </button>
        </span>
      }
      <!-- Textarea field inline -->
      <textarea
        data-testid="tag-input-textarea"
        pTextarea
        [placeholder]="tags.length === 0 ? placeholder : ''"
        [(ngModel)]="currentInput"
        (ngModelChange)="onInputChange($event)"
        (keydown)="onKeydown($event)"
        (blur)="onBlur()"
        [disabled]="disabled"
        class="tag-input-field"
        rows="1"
        [style.resize]="'vertical'"
        #inputRef
      ></textarea>
    </div>
  </div>
</div>

